<template>
    <Layout class="bg-account">
        <Row type="flex" justify="center" align="middle" class="min-h-100vh py-5">
            <Col :xs="24" :md="22" :lg="20">
                <Card class="shadow">
                    <Row align="middle">
                        <Col :xs="24">
                            <Steps :current="data.current">
                                <Step :title="$t('model.register.officer.title')"> </Step>
                                <Step :title="$t('model.register.officer.check')"> </Step>
                                <Step :title="$t('model.register.officer.verifyIdentity')"> </Step>
                                <Step :title="$t('model.register.officer.success')"> </Step>
                            </Steps>
                            <div v-if="data.current === 0">
                                <Form :colon="false" :ref="(e) => (refs.form = e)" layout="horizontal" class="mt-2">
                                    <TemplateBuilder
                                        :rowProp="data.rowProp"
                                        :useForm="data.useForm"
                                        :fields="data.fields"
                                        :skeleton="isLoading"
                                    ></TemplateBuilder>
                                </Form>
                            </div>
                            <div v-if="data.current === 1">
                                <Form :colon="false" :ref="(e) => (refs.form = e)" layout="horizontal" class="mt-2">
                                    <TemplateBuilder
                                        :rowProp="data.rowProp"
                                        :useForm="data.useForm"
                                        :fields="data.fields"
                                        :skeleton="isLoading"
                                    ></TemplateBuilder>
                                </Form>
                                <Divider></Divider>
                                <Card>
                                    <p>{{ $t("views.register.condition") }}</p>
                                    <Checkbox v-model:checked="data.useForm.modelRef.acceptCondition" required>
                                        <span><a v-bind:href="data.pdpa" target="_blank">{{$t("views.register.pdpa")}} </a></span>
                                        <span>{{ $t("views.register.acceptCondition") }}</span>
                                    </Checkbox>
                                    <div class="has-error" v-if="data.useForm.validateInfos['acceptCondition']?.validateStatus === 'error'">
                                        <div class="ant-form-explain">
                                            {{ data.useForm.validateInfos["acceptCondition"]?.help }}
                                        </div>
                                    </div>
                                </Card>
                            </div>
                            <div v-if="data.current === 2">
                                <VerifyIdentityFileForm
                                    :menuContext="menuContext"
                                    :viewOnly="viewOnly"
                                    :dataProp="data"
                                    :isLoading="isLoading"
                                ></VerifyIdentityFileForm>
                            </div>
                            <div v-if="data.current === 3">
                                <div class="text-center">
                                    <div><img :src="data.lastPageImg" style="width: 15%" /></div>
                                    <div>
                                        <h1 style="color: #ffbf00">{{ $t("model.register.wait") }}</h1>
                                    </div>
                                    <div>{{ data.lastPageDetail }}</div>
                                </div>
                            </div>
                            <div class="d-flex mt-2">
                                <Button
                                    @click="() => onPrevRegister({ props, data })"
                                    :disabled="isLoading"
                                    v-if="data.current > 0 && data.current != 3"
                                >
                                    <span>{{ $t("button.prev") }}</span>
                                </Button>
                                <Button
                                    class="btn-primary ml-auto"
                                    @click="() => onNextRegister({ props, data })"
                                    :disabled="isLoading"
                                    v-if="data.current != 3"
                                >
                                    <span>{{ $t("button.next") }}</span>
                                </Button>
                                <Button
                                    class="btn-primary ml-auto"
                                    @click="() => router.push({ name: 'login' })"
                                    :disabled="isLoading"
                                    v-if="data.current === 3"
                                >
                                    <span>{{ $t("button.login") }}</span>
                                </Button>
                            </div>
                            <div class="text-center" v-if="data.current != 3">
                                <router-link :to="{ name: 'login' }">{{ $t("button.login") }}</router-link>
                            </div>
                        </Col>
                    </Row>
                </Card>
            </Col>
        </Row>
    </Layout>
</template>

<script>
import { Button, Card, Col, Form, Layout, Row, Steps, Checkbox, Divider } from "ant-design-vue";
import { defineAsyncComponent, defineComponent, reactive } from "vue";
import { state as stateApp } from "../../../app.logic";
import { initForm, isLoading, onNextRegister, onPrevRegister } from "./register-manager.logic";
import router from "../../../router";

export default defineComponent({
    components: {
        Card,
        Divider,
        Checkbox,
        Form,
        Button,
        Layout,
        Row,
        Col,
        Steps,
        Step: Steps.Step,
        TemplateBuilder: defineAsyncComponent(() => import("../../../components/input/template-builder/TemplateBuilder")),
        VerifyIdentityFileForm: defineAsyncComponent(() => import(".././verify-identity-file/VerifyIdentityFileForm.vue")),
    },
    props: {
        menuContext: { default: () => stateApp.menuContext },
        viewOnly: { default: false },
    },
    setup(props) {
        const data = reactive({ rowProp: { gutter: 24 }, pdpa: `${process.env.VUE_APP_PUBLIC_PATH}/pdpa` });
        const refs = reactive({ form: null });
        initForm({ props, data, refs });
        return {
            props,
            data,
            onNextRegister,
            onPrevRegister,
            refs,
            router,
            isLoading,
        };
    },
});
</script>

<style scoped>
.bg-account {
    background-image: url("../../../assets/bg/bg-account.jpg");
    background-size: 100% 100%;
}
</style>
